import api, { ApiResponse } from './index'
import {
    SuccessStory,
    CreateSuccessStoryData,
    UpdateSuccessStoryData,
    SuccessStoriesResponse,
    SuccessStoriesFilters
} from '@/types/successStory'

export const successStoriesApi = {
    // Public endpoints - no authentication required

    /**
     * Get all published success stories with pagination and filtering
     */
    getSuccessStories: (params: SuccessStoriesFilters = {}): Promise<ApiResponse<SuccessStoriesResponse>> =>
        api.get('/success-stories', { params }),

    /**
     * Get single success story by ID (public view - only published stories)
     */
    getSuccessStoryById: (id: string): Promise<ApiResponse<{ story: SuccessStory }>> =>
        api.get(`/success-stories/${id}`),

    /**
     * Get user's own story for editing (can be any status)
     */
    getUserStoryForEdit: (id: string): Promise<ApiResponse<{ story: SuccessStory }>> =>
        api.get(`/success-stories/edit/${id}`),

    /**
     * Get success stories by category
     */
    getSuccessStoriesByCategory: (category: string, params?: SuccessStoriesFilters): Promise<ApiResponse<SuccessStoriesResponse>> =>
        api.get(`/success-stories/category/${category}`, { params }),

    /**
     * Get featured stories (for homepage)
     */
    getFeaturedSuccessStories: (limit: number = 5): Promise<ApiResponse<{ stories: SuccessStory[] }>> =>
        api.get('/success-stories/featured', { params: { limit } }),

    /**
     * Search success stories
     */
    searchSuccessStories: (query: string, params?: SuccessStoriesFilters): Promise<ApiResponse<SuccessStoriesResponse>> =>
        api.get('/success-stories/search', { params: { query, ...params } }),

    // User authenticated endpoints

    /**
     * Get current user's success story (if exists)
     */
    getUserSuccessStory: (): Promise<ApiResponse<{ story: SuccessStory | null }>> =>
        api.get('/success-stories/user/my-story'),

    /**
     * Create a new success story (one per user)
     */
    createSuccessStory: (data: CreateSuccessStoryData): Promise<ApiResponse<{ story: SuccessStory }>> =>
        api.post('/success-stories', data),

    /**
     * Update user's own pending story
     */
    updateSuccessStory: (id: string, data: UpdateSuccessStoryData): Promise<ApiResponse<{ story: SuccessStory }>> =>
        api.put(`/success-stories/${id}`, data),

    /**
     * Delete user's own story (only if pending)
     */
    deleteSuccessStory: (id: string): Promise<ApiResponse<{ message: string }>> =>
        api.delete(`/success-stories/${id}`),

    /**
     * Mark story as helpful (increment helpful counter)
     */
    markStoryHelpful: (id: string): Promise<ApiResponse<{ message: string }>> =>
        api.post(`/success-stories/${id}/helpful`, {})
}